<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<h1 class="title">Twenty to <span class="bold">Knit</span></h1>
<p class="sub_heading"><span class="bold">Knitted Baby Mitts</span></p>
<p class="author">Sian Brown</p>
<div class="img_container-1">
<img alt="images" src="images/pub.jpg"/>
</div>
<div class="img_container">
<img alt="images" src="images/title.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?233fdcf6